export default function buy(buyCode, basicInfo) {
  let buyParams = {
    "pack":"common",
    "flowout_spec":"5000",
    "ord_time":"24:Month",
    "order_num":1
  };
  if (basicInfo.duration=="5千") {
    buyParams.flowout_spec = "5000"
  } else if (basicInfo.duration=="5万") {
    buyParams.flowout_spec = "50000"
  } else if (basicInfo.duration=="50万") {
    buyParams.flowout_spec = "500000"
  }
  // PC和H5分开传递
  if ($(window).width() <= 768) {
    // H5的逻辑
    const url = `https://common-buy.aliyun.com/mobileV3?request=${encodeURIComponent(JSON.stringify(buyParams))}&sign=group_buy&groupBuyCode=${buyCode}&commodityCode=newdysmsbag`;
    location.href = url;
  } else {
    const url = `https://common-buy.aliyun.com/?request=${encodeURIComponent(JSON.stringify(buyParams))}&sign=group_buy&groupBuyCode=${buyCode}&commodityCode=newdysmsbag`;
    location.href = url;
  }
}


// WEBPACK FOOTER //
// ./src/commonbuy/buy.js